import React from 'react';

const SOFTFLO_BASE_URL =
  process.env.REACT_APP_SOFTFLO_URL || 'https://softflo.co.kr';

const softfloUrl = (path = '') => `${SOFTFLO_BASE_URL}${path}`;

const FooterLink = ({ href, children }) => (
  <a
    href={href}
    className="text-xs font-medium text-slate-400 transition hover:text-white"
    target="_blank"
    rel="noopener noreferrer"
  >
    {children}
  </a>
);

const FooterColumn = ({ title, children }) => (
  <div className="flex flex-col gap-2.5">
    <h3 className="text-xs font-bold text-slate-100">{title}</h3>
    {children}
  </div>
);

const Footer = () => {
  return (
    <footer className="mt-auto border-t border-slate-800 bg-slate-950 text-slate-400">
      <div className="mx-auto max-w-7xl px-4 py-10 sm:px-6 lg:px-8">
        <div className="grid gap-10 lg:grid-cols-[minmax(320px,1fr)_minmax(320px,0.8fr)]">
          <div>
            <img
              src="/images/softflo/primary-logo-dark.webp"
              alt="SoftFlo"
              className="h-auto w-60 max-w-full"
              loading="lazy"
            />
            <p className="mt-4 max-w-md text-sm leading-7 text-slate-400">
              AI와 데이터로 부동산 비즈니스의 흐름을 연결합니다.
            </p>
            <div className="mt-6 grid gap-1.5 text-xs leading-6 text-slate-500">
              <span>주식회사 소프트플로 · 대표자 송의승</span>
              <span>사업자등록번호 654-86-03832</span>
              <span>서울특별시 서초구 강남대로37길 56-31 서현빌딩 3층, A447</span>
              <span>전화 02-333-5624 · 이메일 contact@softflo.co.kr</span>
              <span>통신판매업신고번호 제 2026-서울서초-3218호</span>
            </div>
          </div>

          <div className="grid gap-8 sm:grid-cols-2 lg:justify-self-end lg:min-w-[320px]">
            <FooterColumn title="Policy">
              <FooterLink href={softfloUrl('/policies/terms')}>이용약관</FooterLink>
              <FooterLink href={softfloUrl('/policies/privacy')}>개인정보처리방침</FooterLink>
              <FooterLink href={softfloUrl('/policies/paid-service')}>유료서비스 이용정책</FooterLink>
              <FooterLink href={softfloUrl('/policies/refund')}>취소·환불정책</FooterLink>
            </FooterColumn>
            <FooterColumn title="Support">
              <FooterLink href={softfloUrl('/faq')}>FAQ</FooterLink>
              <FooterLink href={softfloUrl('/inquiry')}>문의하기</FooterLink>
              <FooterLink href={softfloUrl('/education')}>교육센터</FooterLink>
            </FooterColumn>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-4 border-t border-slate-800 pt-6 text-xs text-slate-500 md:flex-row md:items-center md:justify-between">
          <span>© 2026 SoftFlo Inc.</span>
          <div className="flex gap-5">
            <FooterLink href={softfloUrl('/policies/terms')}>이용약관</FooterLink>
            <FooterLink href={softfloUrl('/policies/privacy')}>개인정보처리방침</FooterLink>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
